import axios from 'axios';

import { i18n } from '@src/configs/i18n.configs';
import { API_URL } from '@src/constants';
import { authLogoutUtils } from '@src/helpers/auth.helpers';
import {
  getToken,
  isErrorException,
  isUnauthenticatedError,
  transformErrorMessage,
} from '@src/helpers/axios.helpers';
import {
  clearSearchParamsByHistoryAPI,
  getLocaleCodeBySubdomain,
} from '@src/helpers/host.helpers';

const localeCode = getLocaleCodeBySubdomain();

export const axiosInstance = axios.create({
  baseURL: API_URL,
  withXSRFToken: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;

    if (config.sendLocale) {
      config.params = {
        ...config.params,
        locale: localeCode,
      };
    }

    return config;
  },
  (error) => error,
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const isMethodGet = error.config.method === 'get';
    const isHideDefaultErrorMessage = error.config.hideDefaultErrorMessage;

    if (
      !isMethodGet &&
      !isErrorException(error) &&
      !isHideDefaultErrorMessage
    ) {
      alert(
        i18n.t('default:navigator.sorry') +
          '\n' +
          i18n.t('default:navigator.noWorries'),
      );
    }

    if (isUnauthenticatedError(error)) {
      clearSearchParamsByHistoryAPI();
      await authLogoutUtils();
    }

    transformErrorMessage(error);

    return Promise.reject(error);
  },
);
